import useSWR from 'swr';

import { fetchJackpotCampaigns } from '@/api/jackpot';

export const JACKPOT_POLL_INTERVAL = 3000;

export const useCurrentJackpotCampaign = () => {
  const { data, error, isLoading } = useSWR(
    'jackpot-campaigns',
    fetchJackpotCampaigns,
    { refreshInterval: JACKPOT_POLL_INTERVAL }
  );

  return {
    campaign: data?.campaigns[0],
    isLoading,
    isResolved: Boolean(data || error),
  };
};
